import { FormattedMessage } from 'react-intl';

type Discount = {
  code?: string;
  discountAmount?: string;
};

type SummaryDetailsProps = {
  orderNumber: string;
  createdAt?: string;
  subTotal?: string;
  discount: Discount;
  total?: string;
};

export const SummaryDetails = ({
  orderNumber,
  createdAt,
  subTotal,
  discount,
  total,
}: SummaryDetailsProps) => (
  <>
    <h2 className="mb-0">
      <FormattedMessage
        id="payment.order.details.summary"
        defaultMessage="Order summary"
        description="Order summary heading"
      />
    </h2>

    <dl className="attribute-list">
      <div className="attribute">
        <dt>
          <FormattedMessage
            id="payment.order.details.number"
            defaultMessage="Order number"
            description="Order number title"
          />
        </dt>
        <dd>{orderNumber}</dd>
      </div>

      <div className="attribute">
        <dt>
          <FormattedMessage
            id="payment.order.details.date"
            defaultMessage="Order date"
            description="Order date title"
          />
        </dt>
        <dd>{createdAt}</dd>
      </div>

      <div className="attribute">
        <dt>
          <FormattedMessage
            id="payment.order.details.subtotal"
            defaultMessage="Subtotal"
            description="Order subtotal"
          />
        </dt>
        <dd>{subTotal}</dd>
      </div>

      <div className="attribute">
        <dt>
          <FormattedMessage
            id="payment.order.details.discount.code"
            defaultMessage="Discount code"
            description="Order discount code"
          />
        </dt>
        <dd>{discount?.code ?? '-'}</dd>
      </div>

      <div className="attribute">
        <dt>
          <FormattedMessage
            id="payment.order.details.discount.amount"
            defaultMessage="Discount amount"
            description="Order discount amount"
          />
        </dt>
        <dd>{discount?.discountAmount}</dd>
      </div>

      <div className="attribute">
        <dt>
          <FormattedMessage
            id="payment.order.details.total"
            defaultMessage="Total after discount"
            description="Total amount after the discount"
          />
        </dt>
        <dd>{total}</dd>
      </div>
    </dl>
  </>
);
